import { useEffect, useState } from "react";
import { cn } from "@/lib/utils";

const COUNTRY_FLAG_CDN_BASE =
  "https://purecatamphetamine.github.io/country-flag-icons/3x2";

export function countryFlagUrl(country: string): string {
  return `${COUNTRY_FLAG_CDN_BASE}/${country}.svg`;
}

/** Matches `.PhoneInputCountryIcon` / `--border` in `index.css`. */
export const countryFlagBoxClassName =
  "inline-flex h-5 w-7 max-w-7 shrink-0 overflow-hidden rounded-sm shadow-[0_0_0_1px_var(--color-surface-200)]";

export interface CountryFlagProps {
  /** ISO 3166-1 alpha-2; invalid codes soft-fail to null render. */
  country?: string | null;
  className?: string;
}

export function CountryFlag({ country, className }: CountryFlagProps) {
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    setHasError(false);
  }, [country]);

  if (!country || hasError) return null;

  return (
    <span
      className={cn(countryFlagBoxClassName, "leading-none", className)}
      aria-hidden="true"
    >
      <img
        alt=""
        src={countryFlagUrl(country)}
        className="block h-full w-full max-h-full max-w-full object-cover"
        onError={() => setHasError(true)}
      />
    </span>
  );
}
